import Pusher from "pusher-js"

export const PusherSocket = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
  cluster: "eu"
})
